import axios from 'axios'

export default axios.create({
    baseURL: 'https://kanban-server-frs.herokuapp.com/'
  });